import logoConducttr from "@/assets/logos/white/conducttr.png";
import logoCurvegrid from "@/assets/logos/white/curvegrid.webp";
import logoElliptic from "@/assets/logos/white/elliptic.webp";
import logoGoproxies from "@/assets/logos/white/goproxies.webp";
import logoGtg from "@/assets/logos/white/gtg.webp";
import logoKuration from "@/assets/logos/white/kuration.webp";
import logoMysterium from "@/assets/logos/white/mysterium.svg";
import logoSupervised from "@/assets/logos/white/supervised.webp";
import logoVeil from "@/assets/logos/white/veil.webp";
import logoWingbits from "@/assets/logos/white/wingbits.webp";

const logos = [
  { src: logoConducttr, alt: "Conducttr" },
  { src: logoCurvegrid, alt: "Curvegrid" },
  { src: logoElliptic, alt: "Elliptic" },
  { src: logoGoproxies, alt: "GoProxies" },
  { src: logoGtg, alt: "Good to Go Studio" },
  { src: logoKuration, alt: "Kuration AI" },
  { src: logoMysterium, alt: "Mysterium VPN" },
  { src: logoSupervised, alt: "Supervised" },
  { src: logoVeil, alt: "Hause of Veil" },
  { src: logoWingbits, alt: "Wingbits" },
];

export function TrustStrip({
  label = "TRUSTED BY FOUNDERS AND LEAN MARKETING TEAMS ACROSS SEVERAL INDUSTRIES",
}: {
  label?: string;
}) {
  return (
    <section className="px-6 pt-4 pb-10">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.18em] text-center text-white/80 mb-4">
          {label}
        </p>
        <div className="glass-card px-6 py-6">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-x-8 gap-y-6 items-center justify-items-center">
            {logos.map((l) => (
              <img
                key={l.alt}
                src={l.src}
                alt={l.alt}
                width={128}
                height={32}
                className="h-8 w-32 object-contain opacity-75 hover:opacity-100 transition-opacity"
                loading="lazy"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
